import React from 'react';
import classNames from 'classnames';
import numeral from 'numeral';

import UpArrow from '@buyside/svgs/triangle_up.svg';
import DownArrow from '@buyside/svgs/triangle_down.svg';

import { Maybe } from '@interfaces/graphql-typings';

import styles from './returnValueStyles.scss';

const ReturnValue: React.FC<{ value: Maybe<number> }> = ({ value }) => (
  <p
    className={classNames(styles.return, {
      [styles.negativeReturn]: value && value < 0,
      [styles.pendingReturn]: !value
    })}
  >
    {value ? (
      <>
        {value > 0 ? <UpArrow /> : <DownArrow />}
        {numeral(value).format('0,0.00')}%
      </>
    ) : (
      <>Pending...</>
    )}
  </p>
);

export default ReturnValue;
